class MiniCart extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector("sticky-header");
    this.drawer = document.querySelector("cart-drawer");
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);

    fetch(this.dataset.url)
      .then((response) => response.text())
      .then((html) => {
        document.getElementById("mini-cart").innerHTML =
          this.getSectionInnerHTML(html, ".shopify-section");

        document.dispatchEvent(new CustomEvent("cartdrawer:opened"));
      })
      .catch((e) => {
        console.error(e);
      });
  }

  open() {
    const detailsElement = this.drawer.querySelector("details");
    if (detailsElement.hasAttribute("open")) {
      return;
    }

    this.drawer.openMenuDrawer();
  }

  renderContents(parsedState) {
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      if (document.getElementById(section.id)) {
        document.getElementById(section.id).innerHTML =
          this.getSectionInnerHTML(
            parsedState.sections[section.id],
            section.selector
          );
      }
    });

    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: "mini-cart",
        section: "mini-cart",
        selector: ".shopify-section",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
      {
        id: "mobile-cart-icon-bubble",
        section: "mobile-cart-icon-bubble",
        selector: ".shopify-section",
      },
    ];
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  // Ripfit Mod: Custom method to refresh the mini-cart and cart icon
  refreshCartDrawer() {
    fetch("/cart.js")
      .then((res) => res.json())
      .then((cart) => {
        // Fetch the mini-cart and cart icon bubble sections
        fetch(window.location.pathname + "?sections=mini-cart,cart-icon-bubble")
          .then((res) => res.json())
          .then((data) => {
            if (data["mini-cart"]) {
              document.getElementById("mini-cart").innerHTML =
                this.getSectionInnerHTML(data["mini-cart"], ".shopify-section");
            }
            if (data["cart-icon-bubble"]) {
              const bubble = document.getElementById("cart-icon-bubble");
              if (bubble) {
                bubble.innerHTML = this.getSectionInnerHTML(
                  data["cart-icon-bubble"],
                  ".shopify-section"
                );
              }
            }
            this.open();
          });
      });
  }
}

customElements.define("mini-cart", MiniCart);
